import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  CircularProgress,
} from "@mui/material";
import { useGetEngageAudiencesQuery } from "../../api/engageApi";
import { AUDIENCE_SECTIONS } from "./constants";

const AudienceDialog = ({ open, selectedId, onClose, onConfirm }) => {
  const { data: audiences, isLoading, isError } = useGetEngageAudiencesQuery(
    undefined,
    { skip: !open }
  );
  const [draftId, setDraftId] = useState(selectedId || "");

  useEffect(() => {
    if (open) setDraftId(selectedId || "");
  }, [open, selectedId]);

  const sections = AUDIENCE_SECTIONS.map((section) => ({
    ...section,
    rows: Array.isArray(audiences?.[section.key]) ? audiences[section.key] : [],
  })).filter((section) => section.rows.length > 0);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>
        <span className="text-lg font-semibold text-gray-800">
          Select Group
        </span>
      </DialogTitle>

      <DialogContent dividers>
        {isLoading && (
          <div className="flex justify-center py-8">
            <CircularProgress size={28} />
          </div>
        )}

        {isError && (
          <p className="py-6 text-sm text-red-600">
            Could not load the audience list. Close this and try again.
          </p>
        )}

        {!isLoading && !isError && sections.length === 0 && (
          <p className="py-6 text-sm text-gray-500">
            No departments, designations or locations are set up yet. An admin
            adds these under Manage Lookups.
          </p>
        )}

        {sections.map((section) => (
          <div key={section.key} className="mb-4 last:mb-0">
            <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-gray-400">
              {section.label}
            </p>
            {section.rows.map((row) => (
              <label
                key={row.id}
                className="flex cursor-pointer items-center gap-2 rounded-md px-1 py-1 hover:bg-gray-50"
              >
                <Radio
                  size="small"
                  value={row.id}
                  checked={draftId === row.id}
                  onChange={() => setDraftId(row.id)}
                />
                <span
                  className={
                    draftId === row.id
                      ? "text-sm font-semibold text-blue-700"
                      : "text-sm text-gray-700"
                  }
                >
                  {row.name}
                </span>
              </label>
            ))}
          </div>
        ))}
      </DialogContent>

      <DialogActions>
        <button
          type="button"
          onClick={onClose}
          className="rounded-md px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={!draftId}
          onClick={() => onConfirm(draftId)}
          className="rounded-md bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300"
        >
          Confirm
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default AudienceDialog;
